import React from "react"
import { useDispatch } from "react-redux"

import { Container, Card, Row, Col, Button } from "react-bootstrap"

import {
    toggleMakeEnquiryModal,
    setMakeEnquiryProperty,
} from "@/slices/makeEnquiryModalSlice"

function BottomSticky({ property }) {
    const dispatch = useDispatch()

    return (
        <section className="d-none d-md-flex mb-3 mt-5">
            {/* Bottom Sticky */}
            <Container fluid="md" className="p-0">
                <Card>
                    <div className="px-5 pb-2 pt-4">
                        <Row>
                            <Col xs={5} className="my-auto">
                                <h2>Want more information?</h2>
                            </Col>
                            <Col xs={7}>
                                <Row className="align-items-center justify-content-end h-100">
                                    <Col xs={6} lg={5}>
                                        <Col
                                            xs={12}
                                            as={Button}
                                            variant="outline-warning"
                                            size="lg"
                                            className="px-3 rounded-0"
                                            onClick={() => {
                                                dispatch(
                                                    toggleMakeEnquiryModal(
                                                        true,
                                                    ),
                                                )
                                                dispatch(
                                                    setMakeEnquiryProperty(
                                                        property,
                                                    ),
                                                )
                                            }}
                                        >
                                            <span className="m-0 text-warning">
                                                Make an enquiry
                                            </span>
                                        </Col>
                                    </Col>
                                    {property.documents?.map((document) => {
                                        return document.document_text ===
                                            "Brochure" &&
                                            document.document_url ? (
                                            <Col
                                                xs={6}
                                                lg={5}
                                                key={document.id}
                                            >
                                                <Col
                                                    as={Button}
                                                    size="lg"
                                                    xs={12}
                                                    variant="warning"
                                                    href={document.document_url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="px-2 rounded-0"
                                                >
                                                    <span className="m-0 text-white">
                                                        Download the brochure
                                                    </span>
                                                </Col>
                                            </Col>
                                        ) : null
                                    })}
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Card>
            </Container>
            {/* Bottom Sticky End */}
        </section>
    )
}

export default BottomSticky
